import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ServerConstants } from '../constants/server-constants';
import { RestClient } from './rest-client.service';

@Injectable({
    providedIn: 'root'
})
export class BackendService {
  constructor(private restClient: RestClient) {}

  getProductList(payload){

    return this.restClient.post( ServerConstants.APIGRADE_PRODUCT_LIST, payload);

    // if(filterType == 'Therapeutic Category') {
    //   return this.restClient.get( ServerConstants.PRODUCT_LIST );
    // }else if(filterType == 'Formulation'){
    //   return this.restClient.post( ServerConstants.THEROPATIC_PRODUCT_LIST, {therapeutic_category: theroPetic
    //   });
    // }else if(filterType == 'Available API Grade'){
    //   return this.restClient.post( ServerConstants.FORMULATION_PRODUCT_LIST, {
    //     therapeutic_category: theroPetic,
    //     formulation: formulation
    //   });
    // }else{
    //   return this.restClient.post( ServerConstants.APIGRADE_PRODUCT_LIST, {
    //     therapeutic_category: theroPetic,
    //     formulation: formulation,
    //     apigrade: apiGrade
    //   });
    // }
  }

  serachFormulationList(payload){
    return this.restClient.put( ServerConstants.FORMULATION_SEARCH , payload);
  }

  getAPIGrade(payload){
    return this.restClient.post( ServerConstants.GET_API_GRADE, payload);
  }

  sendEmailToDownloadProduct(payload){
    return this.restClient.post( ServerConstants.SEND_EMAIL, payload);
  }

  saveBusinessForm(payload){
    return this.restClient.post( ServerConstants.SAVE_BUSINESS_FORM, payload);
  }

  saveHomePageEmail(payload){
    return this.restClient.post( ServerConstants.SAVE_HOME_EMAIL, payload);
  }

  saveContactPage(payload){
    return this.restClient.post( ServerConstants.CONTACT_EMAIL, payload);
  }

  saveAdverseForm(payload){
    return this.restClient.post( ServerConstants.SAVE_ADVERSE_FORM, payload);
  }

  saveInjectableForm(payload) {
    return this.restClient.post(ServerConstants.SAVE_INJECTABLE_FORM, payload);
  }

  getCountryList(term){
    return this.restClient.get( ServerConstants.COUNTRY_LIST + '/?location=' + term);
  }

  /*Get IP*/
  getIPAddress(){
    return this.restClient.get("https://api.ipify.org/?format=json");
  }

  getRegionOfInterest() {
    return this.restClient.get(ServerConstants.REGION_LIST);
  }

  /*Accept cookie*/
  acceptCookie(payload){
    return this.restClient.post( ServerConstants.ACCEPT_COOKIE, payload);
  }
}
